module.exports = __webpack_public_path__ + "static/media/outGroup.a39cc729.svg";